import { Component } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'boma-anim-product-search',
  templateUrl: './boma-anim-product-search.component.html',
  styleUrls: ['./boma-anim-product-search.component.scss'],
})
export class AnimProductSearchComponent {
  constructor() {}

  options: AnimationOptions = {
    path: '/assets/lottie/searching-products.json',
  };
}
